import { dropdownValuesService, merchantListService } from "services";

import { dropdownValuesConstants } from "./dropdownValues.constants";

export const dropdownValuesActions = {
	getPdfTemplates,
	getMerchantStatuses,
	getCompanies,
	getTerminals,
	getTimeZone,
	// Select async actions
	loadHeadquartersMerchants,
};

function getPdfTemplates() {
	return dispatch => {
		dispatch(request());

		return dropdownValuesService.getPdfTemplates().then(
			result => {
				dispatch(success(result));
			},
			error => dispatch(failure(error)),
		);
	};

	function request() {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_PDF_TEMPLATES_REQUEST,
		};
	}

	function success(pdfTemplates) {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_PDF_TEMPLATES_SUCCESS,
			pdfTemplates,
		};
	}

	function failure(error) {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_PDF_TEMPLATES_ERROR,
			error,
		};
	}
}

function getMerchantStatuses() {
	return dispatch => {
		dispatch(request());

		return dropdownValuesService.getMerchantStatuses().then(
			result => {
				dispatch(success(result));
			},
			error => dispatch(failure(error)),
		);
	};

	function request() {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_MERCHANT_STATUS_REQUEST,
		};
	}

	function success(merchantStatuses) {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_MERCHANT_STATUS_SUCCESS,
			merchantStatuses,
		};
	}

	function failure(error) {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_MERCHANT_STATUS_ERROR,
			error,
		};
	}
}

function getCompanies({ isActive, merchantCompanyId } = {}) {
	return dispatch => {
		dispatch(request());

		return dropdownValuesService
			.getCompanies({ isActive, merchantCompanyId })
			.then(
				result => dispatch(success(result)),
				error => dispatch(failure(error)),
			);
	};

	function request() {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_COMPANIES_REQUEST,
		};
	}
	function success(companies) {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_COMPANIES_SUCCESS,
			companies,
		};
	}
	function failure(error) {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_COMPANIES_ERROR,
			error,
		};
	}
}

function loadHeadquartersMerchants({
	pattern,
	prevOptions,
	page,
	skipMerchants,
}) {
	return async dispatch => {
		dispatch(request());

		try {
			const { items, count } = await merchantListService.getMerchantList({
				page,
				sort: { id: "name", desc: true },
				filtersApplied: {
					name: pattern,
					isOnlyParent: true,
					skipMerchants,
				},
			});

			const hasMore = prevOptions.length + items.length < count;
			dispatch(success(items));

			return {
				options: items.map(i => ({
					value: i.id,
					label: i.dbaName,
				})),
				hasMore,
				additional: {
					page: page + 1,
				},
			};
		} catch (err) {
			dispatch(failure(err));
			return { options: [] };
		}
	};

	function request() {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_HEADQUARTERS_MERCHANTS_REQUEST,
		};
	}
	function success() {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_HEADQUARTERS_MERCHANTS_SUCCESS,
		};
	}
	function failure(error) {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_HEADQUARTERS_MERCHANTS_ERROR,
			error,
		};
	}
}

function getTerminals() {
	return dispatch => {
		dispatch(request());

		return dropdownValuesService.getTerminals().then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function request() {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_TERMINALS_REQUEST,
		};
	}
	function success(terminals) {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_TERMINALS_SUCCESS,
			terminals,
		};
	}
	function failure(error) {
		return {
			type: dropdownValuesConstants.DROPDOWN_VALUES_GET_TERMINALS_ERROR,
			error,
		};
	}
}

function getTimeZone(timeZone) {
	return dispatch => {
		dispatch(request());

		return dropdownValuesService.getTimeZone(timeZone).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function request() {
		return {
			type: dropdownValuesConstants.DROPDOWN_MERCHANT_TIME_ZONE_REQUEST,
		};
	}
	function success(merchantTimeZone) {
		return {
			type: dropdownValuesConstants.DROPDOWN_MERCHANT_TIME_ZONE_SUCCESS,
			merchantTimeZone,
		};
	}
	function failure(error) {
		return {
			type: dropdownValuesConstants.DROPDOWN_MERCHANT_TIME_ZONE_ERROR,
			error,
		};
	}
}
